import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPageOld from '../features/main/LandingPageOld';
import About from '../features/main/About';
import TestFlyout from '../features/main/TestFlyout';

// auth.ilouli.com URL 가져오기
const getAuthUrl = () => {
  const isLocal = window.location.hostname === 'localhost';
  return isLocal ? 'http://localhost:3001' : 'https://auth.ilouli.com';
};

// auth.ilouli.com으로 리다이렉트하는 컴포넌트
const AuthRedirect = ({ path }) => {
  useEffect(() => {
    const authUrl = getAuthUrl();
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `${authUrl}${path}?returnUrl=${returnUrl}`;
  }, [path]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      color: '#666'
    }}>
      리다이렉트 중...
    </div>
  );
};

const MainRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPageOld />} />
      <Route path="/about" element={<About />} />
      <Route path="/test" element={<TestFlyout />} />
      {/* 인증 관련 경로는 auth.ilouli.com으로 리다이렉트 */}
      <Route path="/login" element={<AuthRedirect path="/login" />} />
      <Route path="/signup" element={<AuthRedirect path="/signup" />} />
      <Route path="/profile" element={<AuthRedirect path="/profile" />} />
    </Routes>
  );
};

export default MainRouter;
